import { Center, Flex, Spinner } from '@chakra-ui/react'
import { useSelectPropertyByRouteLeadId } from 'features/PropertyDetails/infra/react/usePropertyDetailsSelectors'
import { useGetPropertyByRouteLeadId, usePropertyDetailsStore } from 'features/PropertyDetails/infra/react/usePropertyDetailsState'
import { useLayoutStore } from 'presentation/layouts/Layout/hooks/useLayoutStore'
import { NotesSection, usePropertyDetailsMarketingListNotes } from 'presentation/screens/PropertyDetailsScreen/components/NotesSection/NotesSection'
import { mbp } from 'presentation/utils/mapBreakpoint'
import { shallow } from 'zustand/shallow'

export const PropertyNotesScreen = () => {
  useGetPropertyByRouteLeadId()

  const selectProperty = useSelectPropertyByRouteLeadId()
  const height = useLayoutStore(store => store.totalBodyHeight)
  const propertyState = usePropertyDetailsStore(state => {
    const property = selectProperty(state)

    return {
      parcelId: property?.status === 'with-details' ? property.parcelId : null,
      isLoading: state.actions.getProperty.state.status === 'loading',
    }
  }, shallow)
  const notesState = usePropertyDetailsMarketingListNotes(propertyState.parcelId)

  if (!propertyState.parcelId && propertyState.isLoading) {
    return (
      <Center h='full' minH={height}>
        <Spinner />
      </Center>
    )
  }

  return (
    <Flex
      flexDirection='column'
      minH={height}
      h='full'
      bgColor='neutral.200'
      maxW='1360px'
      w='full'
      mx={mbp({ mobSm: '0', dtSm: 'auto' })}
      px={mbp({ mobSm: 1, mob: 3, dtSm: 3, dtLg: 4 })}
      py={mbp({ mobSm: 2, dtSm: 3 })}
    >
      <NotesSection
        parcelId={propertyState.parcelId || ''}
        notes={notesState.notes}
        loading={notesState.loading}
        refetch={notesState.refetch}
      />
    </Flex>
  )
}
